export default {
  /** 找出两个对象的改动 **/
  diffObjValue(originObj, modifyObj) {
    const resObj = {}
    let count = 0
    Object.keys(modifyObj).forEach((key) => {
      const oVal = originObj[key] && typeof originObj[key] === 'object' ? JSON.stringify(originObj[key]) : originObj[key]
      const mVal = modifyObj[key] && typeof modifyObj[key] === 'object' ? JSON.stringify(modifyObj[key]) : modifyObj[key]
      if (oVal !== mVal) {
        count++
        resObj[key] = modifyObj[key]
      }
    })
    return count ? resObj : false
  },
  /** 排序处理方法
   * @params val: {prop: '', order: ''}
   * **/
  handleTableSort(val, matchObj) {
    if (!val || !val.prop) {
      return {}
    } else {
      const sortField = matchObj[val.prop]
      return {
        sortField,
        orderType: val.order === 'ascending' ? 'ASC' : 'DESC'
      }
    }
  },
}
